import { combineReducers, configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import { reduxBatch } from '@manaflair/redux-batch'
import { connectRouter, routerMiddleware } from 'connected-react-router'

import { history } from '../services/history'

import commonReducer, { COMMON_REDUCER_KEY } from './commonSlice'
import stationForecastPageReducer, {
    initExceptedRoutes,
    STATION_FORECAST_PAGE_REDUCER_KEY,
} from './stationForecastPageSlice'
import stationSearchByTypePageSlice, { STATION_SEARCH_BY_TYPE_PAGE_REDUCER_KEY } from './stationSearchByTypePageSlice'
import { saveUserConfigMiddleware } from './saveUserConfigMiddleware'
import { stationForecastPageMiddleware } from './stationForecastPageMiddleware'
import stationSearchByKeywordPageSlice, {
    STATION_SEARCH_BY_KEYWORD_PAGE_REDUCER_KEY,
} from './stationSearchByKeywordPageSlice'
import stationSearchByLocationPageSlice, {
    STATION_SEARCH_BY_LOCATION_PAGE_REDUCER_KEY,
} from './stationSearchByLocationPageSlice'
import favoritesPageSlice, { FAVORITES_PAGE_REDUCER_KEY, initFavorites } from './favoritesPageSlice'
import historyPageSlice, { initHistory, HISTORY_PAGE_REDUCER_KEY } from './historyPageSlice'

const rootReducer = combineReducers({
    router: connectRouter(history),
    [COMMON_REDUCER_KEY]: commonReducer,
    pages: combineReducers({
        [STATION_FORECAST_PAGE_REDUCER_KEY]: stationForecastPageReducer,
        [STATION_SEARCH_BY_TYPE_PAGE_REDUCER_KEY]: stationSearchByTypePageSlice,
        [STATION_SEARCH_BY_KEYWORD_PAGE_REDUCER_KEY]: stationSearchByKeywordPageSlice,
        [STATION_SEARCH_BY_LOCATION_PAGE_REDUCER_KEY]: stationSearchByLocationPageSlice,
        [FAVORITES_PAGE_REDUCER_KEY]: favoritesPageSlice,
        [HISTORY_PAGE_REDUCER_KEY]: historyPageSlice,
    }),
})

const store = configureStore({
    reducer: rootReducer,
    middleware: [
        ...getDefaultMiddleware(),
        routerMiddleware(history),
        saveUserConfigMiddleware,
        stationForecastPageMiddleware,
    ],
    enhancers: [reduxBatch],
})

// Load favorites stations from LocalStorage
store.dispatch(initFavorites())
// Load history stations from LocalStorage
store.dispatch(initHistory())
// Load excepted routes from LocalStorage
store.dispatch(initExceptedRoutes())

export default store
